import { SkillNames } from "utils/json";
import Rarity from "./Rarity";

export enum SkillType {
  Resolve = "Resolve",
  Common = "Common",
  "Batting Style" = "Batting Style",
  "Batter Skills" = "Batter Skills",
  "Pitching Style" = "Pitching Style",
  "Hand" = "Hand",
  "Pitch Type I" = "Pitch Type I",
  "Pitch Type II" = "Pitch Type II",
  "Pitch Type III" = "Pitch Type III",
  "Pitch Type IV" = "Pitch Type IV",
  "Pitch Type V" = "Pitch Type V",
  "Pitch Type VI" = "Pitch Type VI",
}

export type SkillLevel = 1 | 2 | 3 | 4 | 5;

type ISkill = {
  name: SkillNames;
  skillGrade: Rarity;
  type: SkillType;
};

export type IRosterSkill = ISkill & {
  level: SkillLevel;
  rating: number;
};

export default ISkill;
